import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { BrandForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditBrand({ title, subtitle }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();

  const brand = useSelector((state) => state.brand);
  const [addImage, setAddImage] = useState([]);



  const [showFront, setShowFront] = useState(brand?.show_front);

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: brand.name,
      description: brand.description,
      show_front: brand.show_front,
    },
  });

  useEffect(() => {
    dispatch(actions.brandGet(id));
    setShowFront(brand?.show_front);
    return () => { };
  }, []);

  useEffect(() => {
    if (brand.image) {
      setAddImage([brand.image]);
    }
    return () => { };
  }, [brand]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      if (_.isEmpty(addImage)) {
        const payload = {
          name: data?.name,
          show_front: data?.show_front,
          description: data?.description,
        };
        await dispatch(actions.brandPut(id, payload));
        await dispatch(actions.brandGet(id));
        setAddImage([]);
        alert('สำเร็จ');
        history.push('/wms/brand');
      }
      if (addImage[0].id) {
        const payload = {
          ...data,
          image: addImage[0].id,
        };
        await dispatch(actions.brandPut(id, payload));
        await dispatch(actions.brandGet(id));
        setAddImage([]);
        alert('สำเร็จ');
        history.push('/wms/brand');
      }
      if (addImage[0].data_url) {
        const payload = {
          ...data,
          image: {
            image: addImage[0]?.data_url,
            imageType: 'brand',
            alt: '',
          },
        };
        await dispatch(actions.brandPut(id, payload));
        await dispatch(actions.brandGet(id));
        setAddImage([]);
        alert('สำเร็จ');
        history.push('/wms/brand');
      }
    } catch (error) {
      console.log(error);
    }
  };
  if (brand.isLoading || brand.rows) {
    return <Loading />;
  }
  if (!brand.isLoading && brand.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
          <div className="text-lg font-semibold ml-6">แก้ไขข้อมูลแบรนด์</div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <BrandForm
                errors={errors}
                brand={brand}
                control={control}
                Controller={Controller}
                addImage={addImage}
                setAddImage={setAddImage}
                showFront={showFront}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button
                  variant="contained"
                  type="submit"
                  startIcon={<SaveIcon />}
                >
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditBrand.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditBrand.defaultProps = {
  title: '',
  subtitle: '',
};
